/**
 * Se o sidebar precisa do atalho avulso para /channels. O cabeçalho de cada
 * grupo de canais já leva a engrenagem, mas ele some com o sidebar recolhido
 * e numa conta sem canal. Sem o link Channels na navegação, sobrava só a URL.
 * Na primeira carga, a conta ainda não é "sem canal": nada de piscar o cabeçalho
 * vazio. Já a consulta que falhou conta como terminada: com a lista vazia por
 * erro, os grupos somem, e o atalho é o único caminho que sobra.
 */
export function needsManageChannelsLink(input: {
  collapsed: boolean
  /** A consulta dos canais terminou, com sucesso ou com erro (`!isPending`). */
  channelsSettled: boolean
  channelCount: number
}): boolean {
  return input.collapsed || (input.channelsSettled && input.channelCount === 0)
}
